import Autosave from './autosave';
import AutosaveApi from './autosave-api';
import Keyboard from './keyboard';
import ConsoleDebugger from './console-debugger';

export {
  Autosave,
  AutosaveApi,
  Keyboard,
  ConsoleDebugger
};

export default {
  Autosave,
  AutosaveApi,
  Keyboard,
  ConsoleDebugger
};
